/*jslint browser: true*/
/*global $, jQuery*/

import select2 from 'select2';

function compose_options_array(levels){
    var options = [];
    for (var k in levels) {
	options.push({text: levels[k], value: k});
    }
    return options;
}


function skill_type_not_found(new_type){
    return "Not found?,  <a href='#' data-target='"+ new_type +  "' class='popup_add_missing_type'>Create now?</a>";
}

function init_delete_skill_link(){
    $(".delete_skill_link").click(function(){
	$(this).prev().val("1");
	$(this).closest(".skill-line").hide();
	return false;
    });
}

function init_add_skill_link(){
    $(".add-skill-link").click(function(){
	var new_id = new Date().getTime();
	var regexp = new RegExp("-999999", "g");
	var html_block =$("#empty-line").html().replace(regexp, new_id);
	$("div.skill-grid").append(html_block);
	init_skill_type_select2();
	return false;
    });
}

function init_skill_type_select2(){
    $(".skill-grid .select2-origin > select").select2(
	{ dropdownAutoWidth:true,
	  width: '100%;',
	  allowClear: true,
	  language: { noResults: skill_type_not_found },
	  escapeMarkup: function(markup) { return markup; },
	});
    $(".skill-grid .select2-origin > select").on("change",function(e) {
	if (e.target) {
	    var this_node = $(this);
	    update_levels_by_type(this_node, this_node.parent().next().children("select"));
	}
    });
}

function update_levels_by_type(type_node, level_node){
    if (type_node && type_node.val()) {
	$.getJSON("/skill_types/" + type_node.val() + "/levels", function(result) {
	    var options =  compose_options_array(result);
	    level_node.replace_options(options, true);
	});
    }
}

function popup_add_type(input_text, target_element_id){
    var query = $('.select2-search__field').val();

    $('.select2-dropdown').css('z-index',1000);
    $('#adding_type input.typename').val(query);
    if (target_element_id) $('#adding_type input.element-id').val(target_element_id);

    $('#adding_type').modal('show');
}

function ajax_add_type(url_path){
    $.ajax({url: url_path,
	    type: 'POST',
	    dataType: 'json',
	    data: {"skill_type[type_name]": $('#adding_type input.typename').val()},
	    success: function(data) {
	        update_skill_type_dropdown(data);
	        $('#adding_type').modal('hide');
	    },
	    error: function(xhr, textStatus, errorThrown){
	        alert("Invalid input. " +  xhr.responseText);
	    }});
}

function update_skill_type_dropdown(skill_type){
    var option = $("<option></option>");
    option.val(skill_type.id);
    option.text(skill_type.type_name);

    $('.skill-line .select2-origin > select').prepend(option);

    var current_node_id = $('#adding_type input.element-id').val();
    if (current_node_id){
	$('#' + current_node_id).val(skill_type.id);
    }
}


function init_cond_select2(){
    $(".skill-cond select.select2-origin").select2({  allowClear: true, dropdownAutoWidth:true });
    $(".skill-cond select.select2-origin").on("change",function(e) {
	if (e.target) {
	    var this_node = $(this);
	    update_levels_by_type(this_node, this_node.closest('.skill-cond').find("select.min-level"));
	}
    });
}

function pop_change_level(grade, level_name){
    $('#change_level .modal-body input.level_grade').val(grade);
    $('#change_level .modal-body input.level_name').val(level_name);
    $('#change_level').modal('show');
}

function pop_add_level(e){
    $('#add_level .modal-body input').val("");
    $('#add_level').modal('show');
    e.preventDefault();
}

function init_skill_type_level_mgmt_event(){
    $('a.pop_add_level').click(pop_add_level);

    $('a.change-skill-level-link').click(function(e){
	var tr = $(this).closest('tr');
	pop_change_level(tr.find('td.level-grade').text(),  tr.find('td.level-name').text());
	e.preventDefault();
    });
}

function init_add_skill_type_btn(){
    $('#link_to_add_type').click(function(e){
	ajax_add_type('/skill_types');
	e.preventDefault();
    });
}

function init_add_type_link(){
    $('a.type-add-link').click(function(){ popup_add_type(); });

    $(document).on('click', 'a.popup_add_missing_type', function(e){
	var node = $(this);
	var parent_id = node.closest('.select2-results__options').prop('id'); //select2-talent_skills_attributes_0_type_id-results
	popup_add_type(node.data('target'), parent_id.slice(8,-8));
    });
}

$(document).ready(function(){
    init_delete_skill_link();
    init_add_skill_link();
    init_add_skill_type_btn();
    init_add_type_link();
    init_skill_type_select2();
    init_cond_select2();

    init_skill_type_level_mgmt_event();    //skill_types show.html.erb
});
